import {
  useMutation,
  type UseMutationOptions,
  useQueryClient
} from "@tanstack/react-query";
import { useSearch } from "@tanstack/react-router";

import type {
  UpdateOrderClaimStatusRequestDto,
  UpdateOrderClaimStatusResponseDto
} from "../../dtos/update-order-claim-status-dto";
import { OrderQueryKeys } from "../../generators/order-query-keys";
import { OrderService } from "../../services/order-service";

type UsePostRejectClaimMutationProps = {
  options?: UseMutationOptions<
    UpdateOrderClaimStatusResponseDto,
    unknown,
    UpdateOrderClaimStatusRequestDto
  >;
};

export const usePostRejectClaimMutation = ({
  options
}: UsePostRejectClaimMutationProps = {}) => {
  const queryClient = useQueryClient();
  const { q, page, status, sort } = useSearch({
    from: "/disbursement/claim-history/"
  });

  return useMutation({
    mutationFn: async (payload) => await OrderService.rejectClaim({ payload }),
    ...options,
    onSuccess: async (...args) => {
      const currentPageKey = OrderQueryKeys.getClaimHistoryList({
        limit: 10,
        page,
        q,
        status,
        sort
      }).queryKey;

      // Invalidate and refetch current page
      await queryClient.invalidateQueries({ queryKey: currentPageKey });

      // Invalidate badge count
      await queryClient.invalidateQueries({
        queryKey: OrderQueryKeys.getClaimHistoryBadgeCount._def
      });

      options?.onSuccess?.(...args);
    }
  });
};
